/** Successful cost writes invalidate cost-dependent resources in this tab.
 * Each listener revalidates its own authenticated/scoped SWR key. */
export const COST_PRICES_CHANGED = "frogstat:cost-prices-changed";
export function notifyCostPricesChanged(): void {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(COST_PRICES_CHANGED));
}
export function resourceDependsOnCosts(url: string | null): boolean {
  return !!url && /^\/api\/(product-money|product-costs|cost-prices|period-metrics|workspace\/store-money)(?:[?#]|$)/.test(url);
}
